import * as actionTypes from "store/actions/input/flags/flagsActionTypes";
import * as persistenceActionTypes from "store/actions/persistence/persistenceActionTypes";
import * as uuid from "uuid";

export const INIT_STATE = {
  judgments: [],
  exposures: [],
  stateId: null,
};

const flagsReducer = (state, action) => {
  if (state === undefined) {
    state = INIT_STATE;
  }
  switch (action.type) {
    case persistenceActionTypes.LOAD_SUBMISSION_STARTED:
      return {
        ...INIT_STATE,
      };
    case persistenceActionTypes.LOAD_SUBMISSION_SUCCEEDED:
      return {
        ...INIT_STATE,
        ...action?.payload?.data?.state?.input?.flags,
      };
    case actionTypes.UPDATE_FLAGS:
      return {
        ...state,
        ...action.payload,
      };
    case actionTypes.CREATE_UW_JUDGMENT:
      return {
        ...state,
        judgments: [
          ...state.judgments,
          {
            ...action.payload,
            id: action.payload.id || uuid.v4(),
            canDelete: true,
            canEditName: true,
          },
        ].filter(
          (judgment) => judgment.name || judgment.value || judgment.comments
        ),
      };
    case actionTypes.CREATE_EXPOSURE_FLAG:
      return {
        ...state,
        exposures: [
          ...state.exposures,
          {
            ...action.payload,
            id: action.payload.id || uuid.v4(),
            canDelete: true,
            canEditName: true,
          },
        ],
      };
    case actionTypes.UPDATE_UW_JUDGMENT:
      return {
        ...state,
        judgments: state.judgments.map((judgment) =>
          judgment.id === action.payload.id
            ? {
                ...judgment,
                [action.payload.column]: action.payload.value,
              }
            : judgment
        ),
      };
    case actionTypes.UPDATE_EXPOSURE_FLAG:
      return {
        ...state,
        exposures: state.exposures.map((exposure) =>
          exposure.id === action.payload.id
            ? {
                ...exposure,
                [action.payload.column]: action.payload.value,
              }
            : exposure
        ),
      };
    case actionTypes.DELETE_UW_JUDGMENT:
      return {
        ...state,
        judgments: state.judgments.filter(
          (judgment) => judgment.id !== action.payload
        ),
      };
    case actionTypes.DELETE_EXPOSURE:
      return {
        ...state,
        exposures: state.exposures.filter(
          (exposure) => exposure.id !== action.payload
        ),
      };
    case actionTypes.UPDATE_STATE_ID:
      return {
        ...state,
        stateId: action.payload,
      };
    case actionTypes.UPDATE_JUDGMENT_IGNORE_OVERRIDE:
      return {
        ...state,
        judgmentLimits: {
          ...state?.judgmentLimits,
          ignoreOverrides: action.payload,
        },
      };
    default:
      return state;
  }
};

export default flagsReducer;
